import { Pipe, PipeTransform } from '@angular/core';

import { hasLegend } from 'src/app/constants/constants';

@Pipe({ name: 'hasLegend' })
export class HasLegendPipe implements PipeTransform {
  transform(parameter: string) {
    return hasLegend(parameter);
  }
}
